/**
  ---DO NOT EDIT THIS FILE DIRECTLY---
  This CSS file was concatenated from files listed in the css/ folder as part of a build process
  This is to allow for js import with @import links which will not be followed
**/

/* src/primitives/icon/css/definition/content/icon.css */
@layer icon.definition.singular {
  :host {
    display: inline-block;
    height: 1em;
    font-style: normal;
    font-weight: normal;
    text-decoration: inherit;
    text-align: center;
    margin: 0em var(--icon-distance-from-text) 0em 0em;
    font-size: inherit;
    vertical-align: text-top;
  }
  .icon {
    display: inherit;
    vertical-align: top;
    opacity: var(--icon-opacity);
    width: var(--icon-width);
    height: var(--icon-height);
    backface-visibility: hidden;
    speak: none;
    background: var(--icon-bg, currentColor);
    mask-image: var(--icon-mask, var(--icon-fallback));
    mask-size: 100% 100%;
    mask-repeat: no-repeat;
    background-image: var(--icon-bg-image, none);
    background-size: contain;
    background-repeat: no-repeat;
    font-family: var(--icon-font, inherit);
  }
  .icon::before {
    content: var(--icon-glyph, "");
  }
}

/* src/primitives/icon/css/definition/group/icons.css */
@layer icon.definition.plural;

/* src/primitives/icon/css/definition/states/disabled.css */
@layer icon.definition.states.disabled {
  .disabled.icon {
    cursor: default !important;
    opacity: var(--icon-disabled-opacity) !important;
  }
}

/* src/primitives/icon/css/definition/states/loading.css */
@layer icon.definition.states.loading;

/* src/primitives/icon/css/definition/variations/circular.css */
@layer icon.definition.variations.circular {
  i.circular.icon {
    border-radius: 500em !important;
    line-height: 1 !important;
    padding: var(--circular-padding) !important;
    box-shadow: var(--circular-shadow);
    width: var(--circular-size) !important;
    height: var(--circular-size) !important;
  }
  i.circular.inverted.icon {
    border: none;
    box-shadow: none;
  }
}

/* src/primitives/icon/css/definition/variations/colored.css */
@layer icon.definition.variations.colored {
  .red.icon {
    color: var(--icon-red);
  }
  .orange.icon {
    color: var(--icon-orange);
  }
  .yellow.icon {
    color: var(--icon-yellow);
  }
  .olive.icon {
    color: var(--icon-olive);
  }
  .green.icon {
    color: var(--icon-green);
  }
  .teal.icon {
    color: var(--icon-teal);
  }
  .blue.icon {
    color: var(--icon-blue);
  }
  .violet.icon {
    color: var(--icon-violet);
  }
  .purple.icon {
    color: var(--icon-purple);
  }
  .pink.icon {
    color: var(--icon-pink);
  }
  .brown.icon {
    color: var(--icon-brown);
  }
  .grey.icon {
    color: var(--icon-grey);
  }
  .black.icon {
    color: var(--icon-black);
  }
}

/* src/primitives/icon/css/definition/variations/fitted.css */
@layer icon.definition.variations.fitted {
  :host([fitted]) {
    margin: 0rem;
  }
}

/* src/primitives/icon/css/definition/variations/link.css */
@layer icon.definition.variations.links {
  .hitbox {
    display: inline-block;
    cursor: pointer;
    box-sizing: border-box;
    margin: calc(var(--icon-hitbox-area) * -1);
    padding: var(--icon-hitbox-area);
    color: var(--icon-link-color);
  }
  .hitbox:hover {
    color: var(--icon-link-hover-color);
  }
  .link.icon,
  .link.icons {
    cursor: pointer;
    opacity: var(--icon-link-opacity);
    color: var(--icon-link-color);
    transition: var(--icon-link-transition);
  }
  :is(.link.icon, .link.icons):hover {
    opacity: var(--icon-link-hover-opacity);
    color: var(--icon-link-hover-color);
  }
}

/* src/primitives/icon/css/definition/variations/sizing.css */
@layer icon.definition.variations.sizing {
  .mini.icons .icon,
  .mini.icon {
    font-size: var(--icon-mini);
  }
  .tiny.icons .icon,
  .tiny.icon {
    font-size: var(--icon-tiny);
  }
  .small.icons .icon,
  .small.icon {
    font-size: var(--icon-small);
  }
  .icons .icon,
  .icon {
    font-size: var(--icon-medium);
  }
  .large.icons .icon,
  .large.icon {
    font-size: var(--icon-large);
  }
  .big.icons .icon,
  .big.icon {
    font-size: var(--icon-big);
  }
  .huge.icons .icon,
  .huge.icon {
    font-size: var(--icon-huge);
  }
  .massive.icons .icon,
  .massive.icon {
    font-size: var(--icon-massive);
  }
  .icon:not(.size) {
    content-visibility: auto;
  }
}

/* src/primitives/icon/css/definition/icon-definition.css */

/* src/primitives/icon/css/theme/content/icon-variables.css */
@layer icon.theme.content.icon {
  :host {
    --icon-width: 1em;
    --icon-height: 1em;
    --icon-opacity: 1;
    --icon-distance-from-text: var(--gap-xs);
    --icon-fallback: linear-gradient(transparent, transparent);
  }
}

/* src/primitives/icon/css/theme/group/icons-variables.css */
@layer icon.theme.plural {
  ui-icon {
  }
}

/* src/primitives/icon/css/theme/states/disabled-variables.css */
@layer icon.theme.states.disabled {
  :host {
    --icon-disabled-opacity: 0.2;
  }
}

/* src/primitives/icon/css/theme/states/loading-variables.css */
@layer icon.theme.states.loading {
  :host {
  }
}

/* src/primitives/icon/css/theme/variations/link-variables.css */
@layer icon.theme.variations.link {
  :host {
    --icon-link-opacity: 0.6;
    --icon-link-color: inherit;
    --icon-link-transition: opacity var(--duration) var(--easing), color var(--duration) var(--easing) ;
    --icon-link-hover-opacity: 1;
    --icon-link-hover-color: inherit;
    --icon-hitbox-area: 5px;
  }
}

/* src/primitives/icon/css/theme/variations/colored-variables.css */
@layer icon.theme.variations.colored {
  :host {
    --icon-red: var(--red);
    --icon-orange: var(--orange);
    --icon-yellow: var(--yellow);
    --icon-olive: var(--olive);
    --icon-green: var(--green);
    --icon-teal: var(--teal);
    --icon-blue: var(--blue);
    --icon-violet: var(--violet);
    --icon-purple: var(--purple);
    --icon-pink: var(--pink);
    --icon-brown: var(--brown);
    --icon-grey: var(--grey);
    --icon-black: var(--black);
  }
}

/* src/primitives/icon/css/theme/variations/sizing-variables.css */
@layer icon.theme.variations.sizing {
  :host {
    --icon-mini: var(--mini);
    --icon-tiny: var(--tiny);
    --icon-small: var(--small);
    --icon-medium: inherit;
    --icon-large: var(--24px);
    --icon-big: var(--32px);
    --icon-huge: var(--48px);
    --icon-massive: var(--64px);
  }
}

/* src/primitives/icon/css/theme/icon-theme.css */

/* src/primitives/icon/css/icon.css */
